export default __webpack_public_path__ + "images/historico-de-compras-ico.svg";